<h1 mat-dialog-title>Instalar PWA</h1>
<div mat-dialog-content>
  <p>¿Quieres instalar esta aplicación en tu dispositivo?</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancelar</button>
  <button mat-button (click)="install()">Instalar</button>
</div>
